export const UPLOAD_TAX_ENTRIES_TO_IMPORT = 'UPLOAD_TAX_ENTRIES_TO_IMPORT';
export const UPLOAD_TAX_ENTRIES_TO_IMPORT_SUCCESS = 'UPLOAD_TAX_ENTRIES_TO_IMPORT_SUCCESS';
export const UPLOAD_TAX_ENTRIES_TO_IMPORT_FAILED = 'UPLOAD_TAX_ENTRIES_TO_IMPORT_FAILED';
export const FETCH_TAX_ENTRY_TO_IMPORT_DATA_SUCCESS = 'FETCH_TAX_ENTRY_TO_IMPORT_DATA_SUCCESS';
export const SUBMIT_BATCH_TAX_ENTRIES = 'SUBMIT_BATCH_TAX_ENTRIES';
export const SUBMIT_BATCH_TAX_ENTRIES_SUCCESS = 'SUBMIT_BATCH_TAX_ENTRIES_SUCCESS';
export const SUBMIT_BATCH_TAX_ENTRIES_FAILURE = 'SUBMIT_BATCH_TAX_ENTRIES_FAILURE';
export const RESET_DATA_FOR_BATCH_TAX_ENTRIES = 'RESET_DATA_FOR_BATCH_TAX_ENTRIES';
